import { render, staticRenderFns } from "./OrderDetailsCard.vue?vue&type=template&id=57a5990c&scoped=true"
import script from "./OrderDetailsCard.vue?vue&type=script&lang=js"
export * from "./OrderDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsCard.vue?vue&type=style&index=0&id=57a5990c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5990c",
  null
  
)

export default component.exports